import React, { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import KoraxForms from "./index";

export default function KoraxFormsAdminGate() {
  const { user } = useContext(AuthContext);

  const authorized = Boolean(
    user &&
    (
      user.profile === "admin" ||
      user.profile === "super" ||
      user.super === true
    )
  );

  if (!authorized) {
    return (
      <main
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24
        }}
      >
        <section
          style={{
            background: "#FFFFFF",
            border: "1px solid #E5EAF2",
            borderRadius: 16,
            padding: 32,
            maxWidth: 470,
            width: "100%",
            textAlign: "center"
          }}
        >
          <div
            style={{
              fontSize: 32,
              color: "#0057FF",
              marginBottom: 12
            }}
          >
            403
          </div>

          <h2
            style={{
              color: "#010B36",
              fontSize: 21,
              margin: "0 0 12px"
            }}
          >
            Acesso restrito
          </h2>

          <p
            style={{
              color: "#64748B",
              fontSize: 14,
              lineHeight: 1.7,
              margin: 0
            }}
          >
            A criação e a administração de formulários
            estão disponíveis somente para administradores.
            Você pode enviar modelos ativos diretamente
            pelas Conversas da Korax.
          </p>
        </section>
      </main>
    );
  }

  return <KoraxForms />;
}
